import RedirectOnError from './RedirectOnError';

export default RedirectOnError;
